export const EXPLORE_URLS = {
    HEATMAPS: 'heatmaps',
    REALTIME: 'realtime'
};
